import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter} from '@angular/core';
import { takeWhile } from "rxjs/operators";
import { DecimalPipe } from "@angular/common";
import { Router,NavigationExtras,ActivatedRoute } from '@angular/router';

import {
    PagingInfo
} from "src/app/shared/vo";
import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgCarService
    ,FvmsApiDtgDangerDriveService
    ,FvmsMapApiProvidor
    ,FvmsMainCarService
} from "src/app/shared/service";
import {
    FilterSecToTime
    ,FilterDist
    ,FilterCarStatusTrans
} from "src/app/shared/filter";

@Component({
    selector: 'dtg-car-ext-drive-hist'
    ,templateUrl: './dtg.car.ext.drive.hist.component.html'
    ,providers: [
        FilterSecToTime
        ,DecimalPipe
        ,FilterDist
        ,FilterCarStatusTrans
    ]
})
export class DtgCarExtDriveHistComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    companyInfo:any;
    dateTimeInfo:any;
    selectedUnitId:string;
    selectedCar:any;
    selectedTripInfo:any;
    selectedTripIdx:number = -1;
    isShowDangerDrive:boolean = false;
    mapService:any;
    listTripInfo:any;
    mapTripInfo:any;
    listDangerDriveRule:any[];
    sumCnt:number = 0;
    sumDist:number = 0;
    sumDuration:number = 0;
    sumSpeed:number = 0;
    avgSpeed:number = 0;
    objKeys:any = Object.keys;
    callbackMarker:any;
    markerTripFrom:any;
    markerTripTo:any;
    markerDriveHis:any;
    lineOptionDefault:any = {
        strokeWeight: 3 // 선의 두께
        ,strokeColor: '#343a40' // 선의 색깔
        ,strokeOpacity: 1 // 선의 불투명도(0에서 1 사이값이며 0에 가까울수록 투명)
        ,strokeStyle: 'solid'
    };
    lineOptionActive:any = {
        strokeWeight: 3 // 선의 두께
        ,strokeColor: '#f62d51' // 선의 색깔
        ,strokeOpacity: 1 // 선의 불투명도(0에서 1 사이값이며 0에 가까울수록 투명)
        ,strokeStyle: 'solid'
    };

    // @Input()
    // set selectedCarInput(selectedCar){
    //     if(selectedCar){
    //         this.selectedCar = selectedCar;
    //         this.reloadListDriveHisTripInfo().then((pListTrip) => {
    //             this.hideTripMarker();
    //             this.hideTripMarker();
    //             this.hideTripHisMarker();
    //             this.hideTripHisPolyline();
    //             this.selectedTripInfo = null;
    //             this.selectedTripIdx = -1;
    //             this.reloadListDriveHisAll().then(() => {
    //                 this.reloadSumAll();
    //                 this.unselectTripInfoAll();
    //                 this.mapService.relayout();
    //                 this.fvmsCommonService.setIsLoading(false);
    //             });
    //         });
    //     }
    // }

    constructor(
        private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsMapApiProvidor:FvmsMapApiProvidor
        ,private activatedRoute: ActivatedRoute
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private fvmsApiDtgDangerDriveService:FvmsApiDtgDangerDriveService
        ,private filterCarStatusTrans:FilterCarStatusTrans
        ,private decimalPipe:DecimalPipe
        ,private filterDist:FilterDist
        ,private filterSecToTime:FilterSecToTime
    ){
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.mapService = this.fvmsMapApiProvidor.getMapApiService();
        this.dateTimeInfo = this.fvmsCommonService.getDateInfo();
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.activatedRoute.queryParamMap.subscribe(params => {
            this.selectedUnitId = params.get("unitId");
            // console.log("unitId",this.selectedUnitId);
        });
    }

    // http://localhost:8085/fvms/auth/ext/login/main?unitId=01229522504&x-access-token=eyJhbGciOiJIUzI1NiJ9.eyJpcEFjY2Vzc0RldmljZSI6IjYxLjM5LjE1NS4xOCIsInVzZXJHcm91cElkIjoiMTAwIiwiY29tcGFueUlkIjoiMiIsInRlYW1JZCI6IiIsInR5cGVBY2Nlc3NEZXZpY2UiOiIxIiwiZXhwIjoxNjQ3NTY1NjI3LCJ1c2VySWQiOiJ0ZXN0MDgiLCJhcGlUeXBlIjoic21pbGsifQ.HoqsBywzv1TksaaaAgRCW0u4gxGjc2NoQclxOQp9AsY
    ngOnInit() {
        this.mapService.initMapContainer("map-container-02");
        this.mapService.addControlViewMode();
        this.mapService.addControlZoom();
        this.mapService.addControlCopyright();
        this.mapService.initLatLngBounds();
        this.mapService.initGeocoder();

        this.reloadListCar().then(() => {
            this.reloadListDriveHisTripInfo().then((pListTrip) => {
                this.hideTripMarker();
                this.hideTripMarker();
                this.hideTripHisMarker();
                this.hideTripHisPolyline();
                this.selectedTripInfo = null;
                this.selectedTripIdx = -1;
                this.reloadListDriveHisAll().then(() => {
                    this.reloadSumAll();
                    this.unselectTripInfoAll();
                    this.mapService.relayout();
                });
            });
        });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }

    // 창을 닫는다
    clickCancel(){
        // this.activeModal.close({
        //     "result":"cancel"
        // });
    }

    // unitId 에 해당하는 차량정보를 가져온다
    reloadListCar(){
        this.fvmsCommonService.setIsLoading(true);
        let promise = new Promise<void>((resolve,reject) => {
            let companyId = this.companyInfo?.companyId || 0;
            let teamId = this.currentUserInfo.teamId || "";
            let pagingInfo:PagingInfo = new PagingInfo();
            pagingInfo.pageSize = 99999;
            this.fvmsApiDtgCarService.getListStatus(companyId,null,this.selectedUnitId,teamId,null,pagingInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(response => {
                    if(response.resultStatus === "ok"){
                        if(response.resultValue){
                            // console.log("listCar",response.resultValue);
                            let listCar = response.resultValue;
                            if(!listCar){
                                resolve();
                            }
                            if(listCar.length < 1){
                                resolve();
                            }
                            this.selectedCar = response.resultValue[0];
                            this.fvmsCommonService.setIsLoading(false);
                            resolve();
                        }
                        this.fvmsCommonService.setIsLoading(false);
                        resolve();
                    }
                    this.fvmsCommonService.setIsLoading(false);
                    resolve();
                },err => {
                    console.error("reloadListCar",err);
                    this.fvmsCommonService.setIsLoading(false);
                    resolve();
                },() => {
                    this.fvmsCommonService.setIsLoading(false);
                    resolve();
                });
        });
        return promise;
    }

    // 트립 목록 호출
    reloadListDriveHisTripInfo(){
        let self = this;
        let promise = new Promise((resolve,reject) => {
            let tmpSearchInfo:any = {
                dtgUnitId:this.selectedCar.dtgUnitId
                ,searchDateFrom:this.fvmsCommonService.getDateFromIso()
                ,searchDateTo:this.fvmsCommonService.getDateToIso()
            };

            this.fvmsApiDtgCarService.getListTripInfo(tmpSearchInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    // console.log("reloadListTripInfo",apiResponse);
                    if(apiResponse.resultStatus !== "ok"){
                        // this.fvmsCommonService.setIsLoading(false);
                        this.mapService.relayout();
                        resolve(null);
                    }

                    if(apiResponse.resultStatus === "ok"){
                        if(!apiResponse.resultValue){
                            // this.fvmsCommonService.setIsLoading(false);
                            this.mapService.relayout();
                            resolve(null);
                        }

                        if(apiResponse.resultValue){
                            this.listTripInfo = apiResponse.resultValue;
                            // console.log("reloadListDriveHisTripInfo",this.listTripInfo);
                            resolve(apiResponse.resultValue);
                        }
                    }
                    resolve(null);
                },err => {
                    console.error("reloadListDriveHisTripInfo",err);
                    // this.fvmsCommonService.setIsLoading(false);
                    this.mapService.relayout();
                    resolve(null);
                }
                ,() => {
                    // this.fvmsCommonService.setIsLoading(false);
                    this.mapService.relayout();
                    resolve(null);
                });
        });
        return promise;
    }

    // 트립별로 운행이력을 받아온다
    reloadListDriveHisAll(){
        let promise = new Promise<void>(async (resolve,reject) => {
            if(this.listTripInfo){
                let sizeListTrip = this.listTripInfo.length;
                let idxTripLast = sizeListTrip - 1;
                this.fvmsCommonService.setIsLoading(true);
                for(let idxTrip=0;idxTrip<sizeListTrip;idxTrip++){
                    let itemTrip = this.listTripInfo[idxTrip];
                    await this.reloadListDriveHisPromise(idxTrip,itemTrip.dtgUnitId,itemTrip.fvmsTripCnt,itemTrip.dtgRegDtFrom,itemTrip.dtgRegDtTo);
                    if(idxTrip === 0){
                        // reg_dt desc
                        this.createMarkerTripTo(idxTrip);
                        if(this.markerTripTo){
                            this.mapService.showMarker(this.markerTripTo);
                        }
                    }else if(idxTrip === idxTripLast){
                        // reg_dt desc
                        this.createMarkerTripFrom(idxTrip);
                        if(this.markerTripFrom){
                            this.mapService.showMarker(this.markerTripFrom);
                        }
                        // self.showTripMarker();
                    }
                    this.reloadSummary(idxTrip);
                    this.createPolyline(idxTrip);
                    this.createMarkerDriveHisFrom(idxTrip);
                    this.createMarkerDriveHisTo(idxTrip);
                    // console.log("reloadListDriveHisAll",idxTrip);
                }
                this.fvmsCommonService.setIsLoading(false);
                resolve();
            }
            resolve();
        });
        return promise;
    }

    // 운행이력을 받아온다
    reloadListDriveHisPromise(idxTrip,unitId,fvmsTripCnt,dateFrom,dateTo){
        let promise = new Promise((resolve,reject) => {
            if(!this.listTripInfo){
                resolve(null);
            }
            //data가 너무 많아서 처음 한번만 읽도록
            let itemTrip = this.listTripInfo[idxTrip];
            if(itemTrip.hasOwnProperty("listDriveHistory") === true && itemTrip.listDriveHistory.length > 0){
                resolve(itemTrip.listDriveHistory);
            }else{
                let tmpSearchInfo:any = {
                    dtgUnitId:unitId
                    ,fvmsTripCnt:fvmsTripCnt
                    ,searchDateFrom:dateFrom
                    ,searchDateTo:dateTo
                    ,eventTimeLimitSec:5
                };
                let pagingInfo = {
                    "curPage":1
                    ,"pageSize":60*60*24
                };
                this.fvmsApiDtgCarService.getListDriveHistory(tmpSearchInfo,pagingInfo)
                    .pipe(takeWhile(() => this.isContinue))
                    .subscribe(apiResponse => {
                        if(apiResponse.resultStatus === "ok"){
                            itemTrip["listDriveHis"] = apiResponse.resultValue;
                            resolve(itemTrip.listDriveHis);
                        }
                    },err =>{
                        console.error("reloadListDriveHisPromise",err);
                        resolve(null);
                    }
                    ,() => {
                        resolve(null);
                    });
            }
        });
        return promise;
    }

    // 각 트립의 합계
    reloadSummary(idx){
        try{
            if(!this.listTripInfo){
                return;
            }
            let tripInfo = this.listTripInfo[idx];
            if(!tripInfo.listDriveHis){
                return;
            }

            tripInfo.sumCnt = 0;
            tripInfo.sumDist = 0;
            tripInfo.sumSpeed = 0;
            tripInfo.sumOilUse = 0;

            let listDriveHis = tripInfo.listDriveHis;
            let sumCnt = listDriveHis.length;
            let sumDist = 0;
            let sumSpeed = 0;
            let sumOilUse = 0;

            sumDist = tripInfo.dtgDistAccumulTo - tripInfo.dtgDistAccumulFrom;
            sumOilUse = tripInfo.dtgOilUseAccumulTo - tripInfo.dtgOilUseAccumulFrom;

            listDriveHis.map((item,idx) => {
                sumSpeed += item.dtgSpeed;
            });

            tripInfo.sumCnt = sumCnt;
            tripInfo.sumDist = sumDist;
            tripInfo.sumSpeed = sumSpeed;
            tripInfo.sumOilUse = sumOilUse;
        }catch(ex){
            console.error("reloadSummary",ex);
        }
    }

    // 트립에 합산된 통계를 합산
    reloadSumAll(){
        this.sumCnt = 0;
        this.sumDist = 0;
        this.sumSpeed = 0;
        this.sumDuration = 0;
        this.avgSpeed = 0;
        this.sumDist = 0;
        try{
            if(!this.listTripInfo){
                return;
            }
            // console.log(this.listTripInfo);
            let isSelected = false;
            this.listTripInfo.forEach((item,idx) => {
               if(item.selected){
                   isSelected = true;
               }
            });
            this.listTripInfo.forEach((item,idx) => {
                if(isSelected){
                    if(item.selected){
                        this.sumCnt += item.sumCnt || 0;
                        this.sumDist += item.sumDist || 0;
                        this.sumSpeed += item.sumSpeed || 0;
                        this.sumDuration += item.dtgRegDtDuration || 0;
                    }
                }else{
                    // console.log("reloadSumAll",idx,item.sumDist);
                    this.sumCnt += item.sumCnt || 0;
                    this.sumDist += item.sumDist || 0;
                    this.sumSpeed += item.sumSpeed || 0;
                    this.sumDuration += item.dtgRegDtDuration || 0;
                }

            });
            // console.log(this.sumSpeed,this.sumCnt);
            this.avgSpeed = Math.round(this.sumSpeed / this.sumCnt) || 0;
            this.sumDist = Math.round(this.sumDist * 0.001) || 0;
        }catch(ex){
            console.error("reloadSumAll",ex);
        }
    }

    // 전체 트립의 시작 마커
    createMarkerTripFrom(idxTrip:number){
        if(!this.listTripInfo){
            return;
        }
        let itemTrip = this.listTripInfo[idxTrip];
        let lat = itemTrip.dtgGpsLatFrom;
        let lng = itemTrip.dtgGpsLngFrom;
        if(this.mapService.checkLatLng(lat,lng) === false){
            return;
        }
        if(!itemTrip["latLngFrom"]){
            let latLng = this.mapService.createLatLng(lat,lng);
            itemTrip["latLngFrom"] = latLng;
        }
        if(!itemTrip["latLngFrom"]){
            return;
        }
        if(itemTrip.listDriveHis){
            let imgSrc = this.mapService.getSvgImgTagHome(40,40,"info");
            let imgOption = {
                // imgSrc: "https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/markerStar.png"
                imgSrc: imgSrc
                ,imgWidth:40
                ,imgHeight:40
                ,offsetX:11
                ,offsetY:35
            };
            this.markerTripFrom = this.mapService.createMarkerFromLatLng(
                itemTrip.latLngFrom
                ,0
                ,imgOption
            );
            // this.callbackMarker = this.clickMarker.bind(this,event,idxTrip,idxHis);
            // this.mapService.addMarkerEvent(this.markerTripFrom,"click",this.callbackMarker);
        }
    }

    // 전체 트립의 종료 마커
    createMarkerTripTo(idxTrip:number){
        if(!this.listTripInfo){
            return;
        }
        let itemTrip = this.listTripInfo[idxTrip];
        let lat = itemTrip.dtgGpsLatTo;
        let lng = itemTrip.dtgGpsLngTo;
        if(this.mapService.checkLatLng(lat,lng) === false){
            return;
        }

        if(itemTrip.hasOwnProperty("latLngTo") === false){
            let latLng = this.mapService.createLatLng(lat,lng);
            itemTrip["latLngTo"] = latLng;
        }
        if(itemTrip.hasOwnProperty("latLngTo") === false){
            return;
        }

        if(itemTrip.listDriveHis){
            let imgOption = {
                imgSrc: "assets/images/gis/icon/car.svg"
                ,imgWidth:40
                ,imgHeight:40
                ,offsetX:20
                ,offsetY:40
            };
            this.markerTripTo = this.mapService.createMarkerFromLatLng(
                itemTrip.latLngTo
                ,0
                ,imgOption
            );
            // let callbackMarker = this.clickMarker.bind(this,event,idxTrip,idxHis);
            // this.mapService.addMarkerEvent(this.markerTripTo,"click",callbackMarker);
        }
    }

    // 전체 이력의 시작/종료
    hideTripMarker(){
        if(this.markerTripFrom){
            this.mapService.hideMarker(this.markerTripFrom);
        }
        if(this.markerTripTo){
            this.mapService.hideMarker(this.markerTripTo);
        }
    }

    // 전체 이력의 시작/종료
    showTripMarker(){
        if(this.markerTripFrom){
            this.mapService.showMarker(this.markerTripFrom);
        }
        if(this.markerTripTo){
            this.mapService.showMarker(this.markerTripTo);
        }
    }

    // 각 트립의 시작/종료 마커
    hideTripHisMarker(){
        if(!this.listTripInfo){
            return;
        }
        let sizeList = this.listTripInfo.length;
        for(let a=0;a<sizeList;a++){
            let item = this.listTripInfo[a];
            if(item.markerFrom){
                this.mapService.hideMarker(item.markerFrom);
            }
            if(item.markerTo){
                this.mapService.hideMarker(item.markerTo);
            }
        }
    }

    // 각 트립의 운행선
    hideTripHisPolyline(){
        if(!this.listTripInfo){
            return;
        }

        let sizeList = this.listTripInfo.length;
        for(let a=0;a<sizeList;a++){
            let item = this.listTripInfo[a];
            if(item.polyline){
                this.mapService.hidePolyLine(item.polyline);
            }
            if(item.polylineActive){
                this.mapService.hidePolyLine(item.polylineActive);
            }
        }
    }

    // 트립정보 전체 선택 해제
    unselectTripInfoAll(){
        if(!this.listTripInfo){
            return;
        }
        this.hideTripHisMarker();
        let sizeList = this.listTripInfo.length;
        for(let a=0;a<sizeList;a++){
            let item = this.listTripInfo[a];
            if(item.polyline){
                item.polylineActive.setZIndex(0);
            }
        }
        // this.showTripMarker();
    }

    // 운행이력 선을 만든다
    createPolyline(idxTrip){
        let tripInfo = this.listTripInfo[idxTrip];
        if(!tripInfo){
            return;
        }

        if(tripInfo.hasOwnProperty("listDriveHis") === false){
            return;
        }

        let tmpListDriveHis = tripInfo.listDriveHis;
        let listSize = tmpListDriveHis.length;
        let listLatLng = [];
        for(let a=0;a<listSize;a++){
            let itemHist = tmpListDriveHis[a];
            let lat = itemHist.dtgGpsLat;
            let lng = itemHist.dtgGpsLng;
            if(this.mapService.checkLatLng(lat,lng) === false){
                continue;
            }
            let latLng = this.mapService.createLatLng(itemHist.dtgGpsLat,itemHist.dtgGpsLng);
            listLatLng.push(latLng);
        }

        if(!listLatLng || listLatLng.length < 1){
            return;
        }

        this.mapService.appendLatLngBoundsFromList(listLatLng);

        let polyline = this.mapService.createPolyLineFromList(this.lineOptionDefault,listLatLng);
        tripInfo.polyline = polyline;
        polyline.setZIndex(1);

        let polylineActive = this.mapService.createPolyLineFromList(this.lineOptionActive,listLatLng);
        polylineActive.setZIndex(0);
        tripInfo.polylineActive = polylineActive;

        // if(tripInfo){
        //     let minLat = 999;
        //     let minLng = 999;
        //     let maxLat = 0;
        //     let maxLng = 0;
        //     let self = this;

        //     if(tripInfo.listDriveHis){
        //         let listSize = tripInfo.listDriveHis.length;
        //         let listPosition = tripInfo.listDriveHis.map((itemHistory,idxHis) => {
        //             // LatLng 객체 생성
        //             let position = this.mapService.createLatLng(itemHistory.dtgGpsLat,itemHistory.dtgGpsLng);
        //             if(position){
        //                 itemHistory.position = position;
        //                 // this.mapService.appendLatLngBounds(itemHistory.position);//속도가 너무 느림
        //                 // this.mapService.appendLatLngBoundsFromList();
        //                 // 좌하,우상 좌표 구하기
        //                 if(itemHistory.position.getLat() <= minLat){
        //                     minLat = itemHistory.position.getLat();
        //                 }
        //                 if(itemHistory.position.getLng() <= minLng){
        //                     minLng = itemHistory.position.getLng();
        //                 }
        //                 if(itemHistory.position.getLat() >= maxLat){
        //                     maxLat = itemHistory.position.getLat();
        //                 }
        //                 if(itemHistory.position.getLng() >= maxLng){
        //                     maxLng = itemHistory.position.getLng();
        //                 }
        //             }
        //             return position;
        //         }).filter((itemPosition,idxPosition) => {
        //             let isReturn = false;
        //             if(itemPosition) {
        //                 isReturn = true;
        //             }
        //             return isReturn;
        //         });

        //         // console.log("createPolyline",idxTrip,minLat,minLng,maxLat,maxLng);

        //         if(listPosition && listPosition.length > 0){
        //             // console.log("createPolyline",idx,listPosition);
        //             let polyline = this.mapService.createPolyLineFromList(this.lineOptionDefault,listPosition);
        //             tripInfo.polyline = polyline;
        //             polyline.setZIndex(1);

        //             let polylineActive = this.mapService.createPolyLineFromList(this.lineOptionActive,listPosition);
        //             polylineActive.setZIndex(0);
        //             tripInfo.polylineActive = polylineActive;

        //             // console.log("createPolyline",idx,minLat,minLng,maxLat,maxLng);
        //             let posSW = this.mapService.createLatLng(minLat,minLng);
        //             let posNE = this.mapService.createLatLng(maxLat,maxLng);
        //             // console.log("sw,ne",posSW,posNE);
        //             this.mapService.appendLatLngBounds(posSW);
        //             this.mapService.appendLatLngBounds(posNE);
        //             tripInfo.posSW = posSW;
        //             tripInfo.posNE = posNE;
        //         }
        //     }
        // }
    }

    // 운행이력의 시작지점 마커
    createMarkerDriveHisFrom(idxTrip:number){
        if(!this.listTripInfo){
            return;
        }

        let tripInfo = this.listTripInfo[idxTrip];
        if(!tripInfo){
            return;
        }

        let tmpListDriveHis = tripInfo.listDriveHis;
        if(!tmpListDriveHis || tmpListDriveHis.length < 1){
            return;
        }

        // reg_dt desc
        let listSize = tmpListDriveHis.length;
        let idxHis = listSize - 1;
        let itemHistory = tmpListDriveHis[idxHis];
        if(!itemHistory){
            return;
        }

        let lat = itemHistory.dtgGpsLat;
        let lng = itemHistory.dtgGpsLng;
        if(this.mapService.checkLatLng(lat,lng) === false){
            return;
        }

        let position = this.mapService.createLatLng(lat,lng);
        if(!position){
            return;
        }

        let sampleImgSrc = "http://t1.daumcdn.net/localimg/localimages/07/mapapidoc/red_b.png";
        let imgOption = {
            imgSrc: sampleImgSrc
            ,imgWidth:50
            ,imgHeight:45
            ,offsetX:15
            ,offsetY:43
        };
        let marker = this.mapService.createMarkerFromLatLng(
            position
            ,idxHis
            ,imgOption
        );
        // let callbackMarker = this.clickMarker.bind(this,event,idxTrip,idxHis);
        // this.mapService.addMarkerEvent(marker,"click",callbackMarker);
        tripInfo.markerFrom = marker;
    }

    // 운행이력의 종료지점 마커
    createMarkerDriveHisTo(idxTrip:number){
        if(!this.listTripInfo){
            return;
        }

        let tripInfo = this.listTripInfo[idxTrip];
        if(!tripInfo){
            return;
        }

        let tmpListDriveHis = tripInfo.listDriveHis;
        if(!tmpListDriveHis || tmpListDriveHis.length < 1){
            return;
        }

        // reg_dt desc
        let idxHis = 0;
        let itemHistory = tmpListDriveHis[idxHis];
        if(!itemHistory){
            return;
        }

        let lat = itemHistory.dtgGpsLat;
        let lng = itemHistory.dtgGpsLng;
        if(this.mapService.checkLatLng(lat,lng) === false){
            return;
        }

        let position = this.mapService.createLatLng(lat,lng);
        if(!position){
            return;
        }

        let sampleImgSrc = "http://t1.daumcdn.net/localimg/localimages/07/mapapidoc/blue_b.png";
        let imgOption = {
            imgSrc: sampleImgSrc
            ,imgWidth:50
            ,imgHeight:45
            ,offsetX:15
            ,offsetY:43
        };
        let marker = this.mapService.createMarkerFromLatLng(
            position
            ,idxHis
            ,imgOption
        );
        // let callbackMarker = this.clickMarker.bind(this,event,idxTrip,idxHis);
        // this.mapService.addMarkerEvent(marker,"click",callbackMarker);
        tripInfo.markerTo = marker;
    }

    // 트립 선택
    changeTripInfoSelect(event:any,idx:number,fvmsTripCnt:number){
        if(!this.listTripInfo){
            return;
        }

        this.unselectTripInfoAll();
        this.selectedTripInfo = null;
        this.selectedTripIdx = -1;

        let sizeList = this.listTripInfo.length;
        for(let a=0;a<sizeList;a++){
            let item = this.listTripInfo[a];
            if(idx !== a){
                item.selected = false;
            }else{
                if(event === true){
                    this.selectedTripInfo = item;
                    this.selectedTripIdx = idx;
                    this.hideTripMarker();
                    if(item.polyline){
                        item.polylineActive.setZIndex(2);
                        if(item.markerFrom){
                            this.mapService.showMarker(item.markerFrom);
                        }
                        if(item.markerTo){
                            this.mapService.showMarker(item.markerTo);
                        }
                    }
                }
            }
        }

        this.showTripMarker();
        this.reloadSumAll();
    }

    // 초당 데이터 row mouse over
    showMarkerDriveHis(idxHis:any,driveHis:any){
        // this.selectedTripIdx
        // this.hideMarkerDriveHis();

        if(driveHis.hasOwnProperty("marker") === false){
            let lat = driveHis.dtgGpsLat;
            let lng = driveHis.dtgGpsLng;
            if(this.mapService.checkLatLng(lat,lng) === false){
                return;
            }

            let latLng = this.mapService.createLatLng(driveHis.dtgGpsLat,driveHis.dtgGpsLng);
            if(!latLng){
                return;
            }

            driveHis.position = latLng;

            let imgWidth = 100;
            let imgHeight = 114;
            let carStatus = this.filterCarStatusTrans.transform(driveHis);
            let sampleImgSrc = this.mapService.getSvgImgTagCarWithNo(
                driveHis.dtgCarNo
                ,driveHis.dtgUnitId
                ,carStatus
                ,driveHis.dtgGpsDirection
                ,imgWidth
                ,imgHeight
            );
            let imgOption = {
                imgSrc: sampleImgSrc
                ,imgWidth:imgWidth
                ,imgHeight:imgHeight
                ,offsetX:50
                ,offsetY:60
            };
            let marker = this.mapService.createMarkerFromLatLng(
                latLng
                ,0
                ,imgOption
            );
            if(marker){
                driveHis.marker = marker;
                let iwContent = this.createInfoWindowContent(driveHis);
                let infoWindow = this.mapService.createInfoWindowFromLatLng(latLng,iwContent);
                driveHis.infoWindow = infoWindow;

                this.markerDriveHis = driveHis;
            }
        }

        this.markerDriveHis = driveHis;

        if(!this.markerDriveHis){
            return;
        }
        if(!this.markerDriveHis.marker){
            return;
        }
        this.mapService.showMarker(this.markerDriveHis.marker);
        if(this.markerDriveHis.infoWindow){
            this.mapService.showInfoWindow(this.markerDriveHis.marker,this.markerDriveHis.infoWindow);
        }
    }

    // 초당 데이터 row mouse out
    hideMarkerDriveHis(){
        if(this.markerDriveHis){
            if(this.markerDriveHis.marker){
                this.mapService.hideMarker(this.markerDriveHis.marker);
                if(this.markerDriveHis.infoWindow){
                    this.mapService.hideInfoWindow(this.markerDriveHis.infoWindow);
                }
            }
            this.markerDriveHis = null;
        }
    }

    // 마커의 팝업 생성
    createInfoWindowContent(item){
        let self = this;
        let iwContent = "";
        iwContent += `<div class="card mb-0" style="width:35vw;">`;
        iwContent += `    <div class="card-header p-2 bg-info text-light">`;
        iwContent += `        <div class="h5 card-title mb-0">`;
        iwContent += `            <i class="mdi mdi-car"></i>`;
        iwContent += `            ${item.dtgCarNo}`;
        iwContent += `            <span class="small ml-2">`;
        iwContent += `                [${item.dtgUnitId}]`;
        iwContent += `            </span>`;
        iwContent += `        </div>`;
        iwContent += `    </div>`;
        iwContent += `    <div class="card-body p-2">`;
        iwContent += `        <div class="row">`;
        iwContent += `            <div class="col">`;
        iwContent += `                <ul class="list-group list-group-flush">`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-map-marker"></i>`;
        iwContent += `                            ${item.dtgGpsAddr}`;
        iwContent += `                        </span>`;
        iwContent += `                        <div>`;
        // 적용안됨
        // iwContent += `                            <icon-power [dtgKeyOnYn]="${item.dtgKeyOnYn}" [dtgRegDt]="${item.dtgRegDt}"></icon-power>`;
        // iwContent += `                            <icon-gps [dtgGpsStatus]="${item.dtgGpsStatus}" class="ml-1"></icon-gps>`;
        // iwContent += `                            <icon-network [dtgRssi]="${item.dtgRssi}" class="ml-1"></icon-network>`;
        iwContent += `                        </div>`;
        iwContent += `                    </li>`;
        iwContent += `                </ul>`;
        iwContent += `            </div>`;
        iwContent += `        </div>`;
        iwContent += `        <div class="row">`;
        iwContent += `            <div class="col">`;
        iwContent += `                <ul class="list-group list-group-flush">`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-clock"></i>`;
        iwContent += `                            수신일시`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.dtgRegDt}</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            일일거리`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgDistDaily),'0.0-1')} km</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            누적거리`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgDistAccumul),'0.0-1')} km</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            일일연료소모량`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgOilUseDaily),'0.0-1')} L</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            누적연료소모량`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${this.decimalPipe.transform(this.filterDist.transform(item.dtgOilUseAccumul),'0.0-1')} L</span>`;
        iwContent += `                    </li>`;
        iwContent += `                </ul>`;
        iwContent += `            </div>`;
        iwContent += `            <div class="col">`;
        iwContent += `                <ul class="list-group list-group-flush">`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            속도`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.dtgSpeed} km/h</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            rpm`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${item.dtgRpm} rpm</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            전압`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>${Number(item.dtgBatteryVolt * 0.1).toFixed(1)} V</span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            온도1`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>`;
        iwContent += `                            ${Number(item.dtgTemper1 * 0.1).toFixed(1)}`;
        iwContent += `                            <i class="mdi mdi-temperature-celsius"></i>`;
        iwContent += `                        </span>`;
        iwContent += `                    </li>`;
        iwContent += `                    <li class="list-group-item p-1 d-flex justify-content-between align-items-center">`;
        iwContent += `                        <span>`;
        iwContent += `                            <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                            온도2`;
        iwContent += `                        </span>`;
        iwContent += `                        <span>`;
        iwContent += `                            ${Number(item.dtgTemper2 * 0.1).toFixed(1)}`;
        iwContent += `                            <i class="mdi mdi-temperature-celsius"></i>`;
        iwContent += `                        </span>`;
        iwContent += `                    </li>`;
        iwContent += `                </ul>`;
        iwContent += `            </div>`;
        iwContent += `        </div>`;
        iwContent += `    </div>`;
        iwContent += `</div>`;
        return iwContent;
    }

    clickMarker(event:any,idxTrip:number,idxHis:number){

    }

    // 해당 차량의 위험운전 정보 호출
    reloadDangerDriveRule(){
        let searchInfo = {
            companyId:this.companyInfo.companyId
            ,dtgCarType:this.selectedCar.dtgCarType
        };
        this.fvmsApiDtgDangerDriveService.getListRuleConfig(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listDangerDriveRule = apiResponse.resultValue;
                    if(!this.listDangerDriveRule){
                        return;
                    }
                    let sizeList = this.listDangerDriveRule.length;
                    for(let a=0;a<sizeList;a++){
                        let item = this.listDangerDriveRule[a];
                        item.desc = this.createDangerDriveRuleDesc(item);
                    }
                }
            });
    }

    // 위험운전 설명 텍스트 생성
    createDangerDriveRuleDesc(dangerDriveRule){
        let msg = "";
        switch(dangerDriveRule.dtgDriveRuleType){
            case 1:
            case "1":
                // 과속
                // 도로제한속도 70 km/h 보다 20 km/h 초과 운행 한 경우
                msg = `<span class="text-danger">[과속]</span><span class="ml-1">도로제한속도 ${dangerDriveRule.dtgMaxSpeed} km/h 보다`;
                msg += `${dangerDriveRule.dtgCheckSpeed} km/h 초과 운행 한 경우</span>`;
                break;
            case 2:
            case "2":
                // 장기과속
                // 도로제한속도 70 km/h 보다 20 km/h 초과해서 3 분 이상 운행 한 경우
                msg = `<span class="text-danger">[장기과속]</span><span class="ml-1">도로제한속도 ${dangerDriveRule.dtgMaxSpeed} km/h 보다`;
                msg += `${dangerDriveRule.dtgCheckSpeed} km/h 초과해서`;
                msg += `${dangerDriveRule.dtgCheckSec / 60} 분 이상 운행 한 경우</span>`;
                break;
            case 3:
            case "3":
                // 급가속
                // 6 km/h 이상 속도에서 초당 6 km/h 이상 가속 운행하는 경우
                msg = `<span class="text-danger">[급가속]</span><span class="ml-1">${dangerDriveRule.dtgMaxSpeed} km/h 이상 속도에서`;
                msg += `초당 ${dangerDriveRule.dtgCheckSpeed} km/h 이상 가속 운행하는 경우</span>`;
                break;
            case 4:
            case "4":
                // 급출발
                // 5 km/h 이상 속도에서 출발하여 초당 8 km/h 이상 가속 운행하는 경우
                msg = `<span class="text-danger">[급출발]</span><span class="ml-1">${dangerDriveRule.dtgMaxSpeed} km/h 이상 속도에서 출발하여`;
                msg += `초당 ${dangerDriveRule.dtgCheckSpeed} km/h 이상 가속 운행하는 경우</span>`;
                break;
            case 5:
            case "5":
                // 급감속
                // 초당 9 km/h 이상 감속 운행하고 속도가 6 km/h 이상인 경우
                msg = `<span class="text-danger">[급감속]</span><span class="ml-1">초당 ${dangerDriveRule.dtgCheckSpeed} km/h 이상 감속 운행하고`;
                msg += `속도가 ${dangerDriveRule.dtgMaxSpeed} km/h 이상인 경우</span>`;
                break;
            case 6:
            case "6":
                // 급정지
                // 초당 9 km/h 이상 감속하여 속도가 5 km/h 이하가 된 경우
                msg = `<span class="text-danger">[급정지]</span><span class="ml-1">초당 ${dangerDriveRule.dtgCheckSpeed} km/h 이상 감속하여`;
                msg += `속도가 ${dangerDriveRule.dtgMaxSpeed} km/h 이하가 된 경우</span>`;
                break;
            case 11:
            case "11":
                break;
            case 101:
            case "101":
                // 주행중 속도가 0 km/h 인 경우
                msg = `<span class="text-danger">[공회전]</span><span class="ml-1">주행중 속도가 ${dangerDriveRule.dtgMaxSpeed} km/h 인 경우</span>`;
                break;
            case 102:
            case "102":
                // 주행중 속도가 0 km/h 이고 rpm 이 800 이상인 경우
                msg = `<span class="text-danger">[공회전+고RPM]</span><span class="ml-1">주행중 속도가 ${dangerDriveRule.dtgMaxSpeed} km/h 이고`;
                msg += ` ${dangerDriveRule.dtgCheckRpm} 이상 인 경우</span>`;
                break;
            default :
                break;
        }
        return msg;
    }

    clickShowDangerDrive(){
        this.isShowDangerDrive = true;
        this.reloadDangerDriveRule();
        if(!this.listTripInfo){
            return;
        }
        let sizeListTrip = this.listTripInfo.length;
        for(let idxTrip=0;idxTrip<sizeListTrip;idxTrip++){
            let itemTrip = this.listTripInfo[idxTrip];
            this.reloadListDangerDriveHisPromise(idxTrip,itemTrip.dtgUnitId,itemTrip.fvmsTripCnt,itemTrip.dtgRegDtFrom,itemTrip.dtgRegDtTo).then(() => {
                this.createMarkerDriveHisDanger(idxTrip);
            });
        }
    }

    clickHideDangerDrive(){
        this.isShowDangerDrive = false;
    }

    // 위험운전 데이터 가져온다
    reloadListDangerDriveHisPromise(idx,unitId,fvmsTripCnt,dateFrom,dateTo){
        let promise = new Promise<void>((resolve,reject) => {
            //data가 너무 많아서 처음 한번만 읽도록
            if(this.listTripInfo[idx].hasOwnProperty("listDangerInfoHis") === true){
                resolve(this.listTripInfo[idx].listDangerInfoHis);
            }else{
                let tmpSearchInfo:any = {
                    dtgUnitId:unitId
                    ,fvmsTripCnt:fvmsTripCnt
                    ,searchDateFrom:dateFrom
                    ,searchDateTo:dateTo
                    ,listDtgDriveRuleType:[1,6]
                };
                let pagingInfo = {
                    "curPage":1
                    ,"pageSize":60*60*24
                };
                this.fvmsApiDtgCarService.getListDangerInfoHistory(tmpSearchInfo,pagingInfo)
                    .pipe(takeWhile(() => this.isContinue))
                    .subscribe(apiResponse2 => {
                        if(apiResponse2.resultStatus === "ok"){
                            // console.log("reloadListDangerDriveHistory",apiResponse2.resultValue);
                            this.listTripInfo[idx].listDangerInfoHis = apiResponse2.resultValue;
                            // resolve(this.listTripInfo[idx].listDangerInfoHis);
                            resolve();
                        }
                    });
            }
        });
        return promise;
    }

    createMarkerDriveHisDanger(idxTrip:number){
        if(!this.listTripInfo){
            return;
        }

        let tripInfo = this.listTripInfo[idxTrip];
        let listDangerHis = tripInfo.listDangerInfoHis;
        if(!listDangerHis){
            return;
        }

        let imgOption = {
            imgSrc: "assets/images/gis/icon/alert.png"
            ,imgWidth:20
            ,imgHeight:20
            ,offsetX:10
            ,offsetY:10
        };
        let sizeListDangerHis = listDangerHis.length;
        for(let a=0;a<sizeListDangerHis;a++){
            let item = listDangerHis[a];
            let latLng = this.mapService.createLatLng(item.dtgGpsLatFrom,item.dtgGpsLngFrom);
            if(!latLng){
                continue;
            }
            item.position = latLng;
            let marker = this.mapService.createMarkerFromLatLng(
                latLng
                ,0
                ,imgOption
            );
            if(!marker){
                continue;
            }

            let callbackShow = this.showInfoWindowDangerDrive.bind(this,event,idxTrip,a);
            let callbackHide = this.hideInfoWindowDangerDrive.bind(this,event,idxTrip,a);
            item.callbackShow = callbackShow;
            item.callbackHide = callbackHide;
            this.mapService.addMarkerEvent(marker,"mouseover",callbackShow);
            this.mapService.addMarkerEvent(marker,"mouseout",callbackHide);

            item.marker = marker;
            let iwContent = this.createInfoWindowContentDangerDrive(item);
            let infoWindow = this.mapService.createInfoWindowFromLatLng(item,iwContent);
            item.infoWindow = infoWindow;
            this.mapService.showMarker(marker);
        }
    }

    createInfoWindowContentDangerDrive(item){
        // console.log("createInfoWindowContentDangerDrive",item);
        let foundDangerRule = this.listDangerDriveRule.find((itemRule,idx) => {
            itemRule.dtgDriveRuleType = itemRule.dtgDriveRuleType * 1;
            item.dtgDriveRuleType = item.dtgDriveRuleType * 1;
            return itemRule.dtgDriveRuleType === item.dtgDriveRuleType;
        });
        let iwContent = "";
        iwContent += `<div class="card mb-0" style="width:35vw;">`;
        iwContent += `    <div class="card-header p-2 bg-warning text-light">`;
        iwContent += `        <div class="h5 card-title mb-0">`;
        iwContent += `            <i class="mdi mdi-alert-outline"></i>`;
        iwContent += `            ${item.dtgCarNo}`;
        iwContent += `            <span class="small ml-2">`;
        iwContent += `                [${item.dtgUnitId}]`;
        iwContent += `            </span>`;
        iwContent += `        </div>`;
        iwContent += `    </div>`;
        iwContent += `    <div class="card-body p-2">`;
        iwContent += `        <ul class="list-group list-group-flush">`;
        if(foundDangerRule){
            iwContent += `            <li class="list-group-item p-1 d-flex justify-content-start align-items-center">`;
            iwContent += `                <span>`;
            iwContent += `                    <i class="mdi mdi-checkbox-marked-outline"></i>`;
            iwContent += `                </span>`;
            iwContent += `                <span class="ml-2">${foundDangerRule.desc}</span>`;
            iwContent += `            </li>`;
        }
        iwContent += `            <li class="list-group-item p-1 d-flex justify-content-start align-items-center">`;
        iwContent += `                <span>`;
        iwContent += `                    <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                </span>`;
        iwContent += `                <span class="ml-2">${item.dtgRegDtFrom} ~ ${item.dtgRegDtTo} (${this.filterSecToTime.transform(item.dtgOverSec,"HH:mm:ss")})</span>`;
        iwContent += `            </li>`;
        iwContent += `            <li class="list-group-item p-1 d-flex justify-content-start align-items-center">`;
        iwContent += `                <span>`;
        iwContent += `                    <i class="mdi mdi-checkbox-marked-outline"></i>`;
        iwContent += `                </span>`;
        iwContent += `                <span class="ml-2">${this.createDangerDriveHisDesc(item)}</span>`;
        iwContent += `            </li>`;
        iwContent += `        </ul>`;
        iwContent += `    </div>`;
        iwContent += `</div>`;
        return iwContent;
    }

    createDangerDriveHisDesc(item){
        let msg = "";
        // msg+="("+item.dtgDriveRuleTypeNm+")";
        switch(item.dtgDriveRuleType){
            case 1:
            case "1":
                // 과속
                // 도로제한속도 70 km/h 보다 20 km/h 초과 운행 한 경우
                msg += `<span>당시속도 : ${item.dtgSpeedFrom}km/h</span>`;
                break;
            case 2:
            case "2":
                // 장기과속
                // 도로제한속도 70 km/h 보다 20 km/h 초과해서 3 분 이상 운행 한 경우
            case 3:
            case "3":
                // 급가속
                // 6 km/h 이상 속도에서 초당 6 km/h 이상 가속 운행하는 경우
            case 4:
            case "4":
                // 급출발
                // 5 km/h 이상 속도에서 출발하여 초당 8 km/h 이상 가속 운행하는 경우
            case 5:
            case "5":
                // 급감속
                // 초당 9 km/h 이상 감속 운행하고 속도가 6 km/h 이상인 경우
            case 6:
            case "6":
                // 급정지
                // 초당 9 km/h 이상 감속하여 속도가 5 km/h 이하가 된 경우
                msg += `<span>${(item.dtgSpeedFrom * 0.1).toFixed(1)}km/h</span>`;
                msg += `<i class="mdi mdi-arrow-right mx-1"></i>`;
                msg += `<span>${(item.dtgSpeedTo * 0.1).toFixed(1)}km/h</span>`;
                msg += `<span class="ml-2">( ${((item.dtgSpeedTo - item.dtgSpeedFrom) * 0.1).toFixed(1)}km/h )</span>`;
                break;
            case 11:
            case "11":
                break;
            case 101:
            case "101":
                // 주행중 속도가 0 km/h 인 경우
                break;
            case 102:
            case "102":
                // 주행중 속도가 0 km/h 이고 rpm 이 800 이상인 경우
                msg += `<span>rpm : ${item.dtgOverRpm}</span>`;
                break;
            default :
                break;
        }
        return msg;
    }

    showInfoWindowDangerDrive(event:any,idxTrip:number,idxHis:number){
        if(!this.listTripInfo){
            return;
        }
        let tripInfo = this.listTripInfo[idxTrip];
        if(tripInfo.hasOwnProperty("listDangerInfoHis") === false){
            return;
        }

        let item = tripInfo.listDangerInfoHis[idxHis];
        if(item && item.infoWindow){
            this.mapService.showInfoWindow(item.marker,item.infoWindow);
        }
    }

    hideInfoWindowDangerDrive(event:any,idxTrip:number,idxHis:number){
        if(!this.listTripInfo){
            return;
        }
        let tripInfo = this.listTripInfo[idxTrip];
        if(tripInfo.hasOwnProperty("listDangerInfoHis") === false){
            return;
        }

        let item = tripInfo.listDangerInfoHis[idxHis];
        if(item && item.infoWindow){
            this.mapService.hideInfoWindow(item.infoWindow);
        }
    }
}